import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { createContext, useState } from 'react';

export type FeatureGateLabelActiveContextValue =
  | [boolean, Dispatch<SetStateAction<boolean>>]
  | undefined;

export const FeatureGateLabelActiveContext =
  createContext<FeatureGateLabelActiveContextValue>(undefined);

export function FeatureGateLabelActiveProvider({
  children,
}: PropsWithChildren<object>) {
  const isLabelActiveState = useState(false);
  return (
    <FeatureGateLabelActiveContext.Provider value={isLabelActiveState}>
      {children}
    </FeatureGateLabelActiveContext.Provider>
  );
}
